import { MILLISECONDS_IN_MINUTE } from '@stdlib/constants-time';
import { useQueryClient } from '@tanstack/react-query';
import { useCallback } from 'react';

import { apiRequest } from 'app/utils/request/api';

import { CORE_QUERY_KEYS, ENDPOINTS } from '.';

export function useCardInfos(hotelId: number, bookingCode: string) {
  const queryClient = useQueryClient();

  const getEphemeralKey = useCallback(
    (nonce: string, cardId: string) => {
      const key = [
        CORE_QUERY_KEYS.booking,
        hotelId,
        bookingCode,
        nonce,
        cardId,
      ];

      return queryClient.fetchQuery<{ secret: string }>({
        queryKey: key,
        queryFn: async () => {
          return await apiRequest({
            path: ENDPOINTS.getCardInfos,
            params: { hotelId: hotelId.toString(), bookingCode },
            queryParams: { nonce, cardId },
          });
        },
        staleTime: 5 * MILLISECONDS_IN_MINUTE,
      });
    },
    [queryClient, hotelId, bookingCode]
  );

  return {
    getEphemeralKey,
  };
}
